import { normalizeGardianSesameProfil } from '~~/utils/auth/e_roles'

/** Persistance dev : remplace gardianSesameProfil quand une entrée existe (jamais en prod build). */
export const DEV_GARDIAN_PROFILES_OVERRIDE_STORAGE_KEY = 'monorga.dev.gardianProfilesOverride'

export type DevGardianOverrideState = {
  /** `true` dès que la clé localStorage est présente (y compris liste vide = visiteur / consultation). */
  replaceActive: boolean
  profiles: string[]
}

function filterProfileStrings(value: unknown[]): string[] {
  return value.filter((item): item is string => typeof item === 'string' && item.length > 0)
}

/**
 * Lit l’état de simulation : clé absente → claims OIDC réels ; clé présente → substitution par `profiles` (éventuellement vide).
 */
export function readDevGardianOverrideState(): DevGardianOverrideState {
  if (!import.meta.client || !import.meta.dev) {
    return { replaceActive: false, profiles: [] }
  }
  const raw = localStorage.getItem(DEV_GARDIAN_PROFILES_OVERRIDE_STORAGE_KEY)
  if (raw === null) {
    return { replaceActive: false, profiles: [] }
  }
  try {
    const parsed = JSON.parse(raw) as unknown
    if (Array.isArray(parsed)) {
      return { replaceActive: true, profiles: filterProfileStrings(parsed) }
    }
    if (parsed && typeof parsed === 'object' && Array.isArray((parsed as { profiles?: unknown }).profiles)) {
      return {
        replaceActive: true,
        profiles: filterProfileStrings((parsed as { profiles: unknown[] }).profiles),
      }
    }
  } catch {
    return { replaceActive: false, profiles: [] }
  }
  return { replaceActive: false, profiles: [] }
}

/**
 * En dev, si la simulation est active, `profiles` **remplace** entièrement `gardianSesameProfil` (liste vide = consultation).
 */
export function resolveEffectiveGardianProfilesForDev(
  oidcProfiles: string[],
  overrideState: DevGardianOverrideState
): string[] {
  if (!import.meta.dev || !overrideState.replaceActive) {
    return oidcProfiles
  }
  return normalizeGardianSesameProfil(overrideState.profiles)
}

export function formatDevProfilesApiHeader(profiles: string[]): string {
  return profiles.join(',')
}
